import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import OfficeFluentProvider from '@office-start/office-fluent-provider';
import TeachingUiContainerComponent from '@office-start/teaching-ui-container-component';
import { TeachingUiContainerComponentProps } from '@office-start/teaching-ui-container-component/dist/TeachingUiContainerComponent';
import * as React from 'react';

import { UserProfileService } from '../shared/instrumentation/user-profile.service';
import { bootstrapOfficeStartComponent } from '../shared/office-start/bootstrap-office-start-component';
import { initializeFluentIcons } from '../shared/office-start/initialize-fluent-icons';
import { OfficeStartBootstrapperService } from '../shared/office-start/office-start-bootstrapper.service';
import ReactRenderer from '../shared/react/react-renderer';
import { DocumentService } from '../shared/services/document.service';
import { ThemingService } from '../shared/services/theming.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { ContextService } from '../shared/shared-context/context.service';

type TeachingUserProfileService = TeachingUiContainerComponentProps['userProfileService'];

@Directive({ selector: 'ohp-teaching-ui-react-content' })
export class TeachingUiReactContentDirective extends ReactRenderer implements OnInit, OnDestroy {
    private readonly userProfileService: TeachingUserProfileService;

    private scrollContent: {
        current: HTMLDivElement
    };

    constructor(
        elementRef: ElementRef,
        capabilitiesService: CapabilitiesService,
        private readonly documentService: DocumentService,
        userProfileService: UserProfileService,
        clientStartupConfigService: ClientStartupConfigService,
        contextService: ContextService,
        officeStartBootstrapperService: OfficeStartBootstrapperService,
        themingService: ThemingService
    ) {
        super(elementRef);
        bootstrapOfficeStartComponent(officeStartBootstrapperService, themingService);
        initializeFluentIcons(capabilitiesService, contextService, clientStartupConfigService);
        this.userProfileService = {
            incrementMetric: (name, delay) => userProfileService.incrementMetric(name, delay),
            isFirstVisit: () => userProfileService.isFirstVisit(),
            doesMetricExist: (verifyMetric, exactMatch) => userProfileService.doesMetricExist(verifyMetric, exactMatch)
        };
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    public async getReactElement() {
        if (!this.scrollContent) {
            this.scrollContent = {
                current: this.documentService.nativeDocument.getElementById('officeHome__scroll-content') as HTMLDivElement
            };
        }
        return (
            <OfficeFluentProvider>
                <TeachingUiContainerComponent
                    userProfileService={this.userProfileService}
                    scrollContentRef={this.scrollContent}
                />
            </OfficeFluentProvider>
        );
    }
}
